module Meevo.Components.Controls.SmartMover {
    import MembershipType = Model.MembershipType;

    export class MembershipTypesCollection extends SmartMoverApiCollection<MembershipType> implements IApiCollection<MembershipType> {
        get url() {
            return 'membershipType';
        }
    }
}
